<template>
  <v-reports
    v-if="access.report_sale_by_category"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  >
    <template #search_text>
      <v-btn icon @click="downloadResult">
        <v-icon> mdi-download </v-icon>
      </v-btn>
      <v-dialog v-model="proccesDialog" max-width="400px">
        <v-card>
          <v-list-item-action style="width: 338px; padding-left: 40px">
            <v-progress-linear
              :color="excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'"
              background-color="white"
              height="10"
              style="border: 1px solid rgba(0, 0, 0, 0.26)"
              v-bind:value="excel_dowload_proccess"
              striped
            />
            <v-list-item-action-text
              >{{ $t("download") }}
              {{ excel_dowload_proccess.toFixed() + " %" }}
            </v-list-item-action-text>
          </v-list-item-action>
        </v-card>
      </v-dialog>
      <v-slide-x-reverse-transition>
        <v-btn icon @click="searchActivate">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-slide-x-reverse-transition>
      <v-slide-x-reverse-transition>
        <v-text-field
          v-model="search"
          ref="search_field"
          v-if="search_text"
          :autofocus="search_field"
          class="mt-3 pa-0"
          append-icon="mdi-close"
          @click:append="
            {
              (search_text = false), (search = ''), update(params);
            }
          "
          @change="
            {
              (page = 1), update(params);
            }
          "
          :label="$t('search')"
        ></v-text-field>
      </v-slide-x-reverse-transition>
    </template>
  </v-reports>
  <error404 v-else></error404>
</template>
<script>
import Currency from "../../mixins/settings/currency";
import fileSaver from "file-saver";
import xlsx from "xlsx";
export default {
  loading: false,
  name: "ReportsByCategory",
  mixins: [Currency],
  data: () => ({
    headers: [
      {
        text: "Category",
        value: "category_name",
        available: true,
        disabled: true,
      },
      { text: "Items sold", value: "items_sold", available: true },
      { text: "Gross sales", value: "gross_sales", available: false },
      { text: "Items refunded", value: "items_refunded", available: false },
      { text: "Refunds", value: "refunds", available: false },
      { text: "Discounts", value: "discounts", available: false },
      { text: "Net sales", value: "net_sales", available: true },
      { text: "Cost of goods", value: "cost_of_goods", available: true },
      { text: "Gross profit", value: "gross_profit", available: true },
      
      // {text: 'Taxes', value: 'taxes', available: false}
    ],
    data: [],
    params: {},
    page: 1,
    numPages: 1,
    data_loading: false,
    search_field: false,
    search_text: false,
    search: "",
    current_currency: 1,
    access: null,
    dovnExcel: [],
    excel_name: "Category",
    dialog: false,
    wait: true,
    proccesDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
  }),
  methods: {
    searchActivate() {
      this.search_text = true;
      if (this.search_field && this.$refs["search_field"]) {
        this.$refs["search_field"].focus();
      }
      this.search_field = true;
    },
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      const current_currency = this.current_currency;
      this.params = params;
      this.data_loading = true;
      let start_date = new Date(params.start_date).getTime();
      let end_date = new Date(params.end_date).getTime();
      let categories = this.$communicator.then(
        this,
        await this.$communicator("sales_by_category", {
          arguments: [start_date, end_date, 10, this.page],
          params: {
            search: this.search,
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
          },
        })
      );
      this.max_total = categories.total;
      for (let i = 0; i < categories.data.length; i++) {
        categories.data[i].items_sold =
          Math.round(categories.data[i].items_sold * 100) / 100;
        categories.data[i].cost_of_goods = (
          Math.round(categories.data[i].cost_of_goods * current_currency) /
          current_currency
        ).toLocaleString();
        categories.data[i].discount = (
          Math.round(categories.data[i].discount * current_currency) /
          current_currency
        ).toLocaleString();
        categories.data[i].gross_profit = (
          Math.round(categories.data[i].gross_profit * current_currency) /
          current_currency
        ).toLocaleString();
        categories.data[i].gross_sales = (
          Math.round(categories.data[i].gross_sales * current_currency) /
          current_currency
        ).toLocaleString();
        categories.data[i].net_sales = (
          Math.round(categories.data[i].net_sales * current_currency) /
          current_currency
        ).toLocaleString();
        categories.data[i].refunds = (
          Math.round(categories.data[i].refunds * current_currency) /
          current_currency
        ).toLocaleString();
      }
      this.data_loading = false;
      this.data = categories.data;
      this.numPages = categories.page;
    },
    async downloadResult() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      this.loading = true;
      const limit = 500;
      let all_data = [];
      const current_currency = this.current_currency;
      const start_date = new Date(this.params.start_date).getTime();
      const end_date = new Date(this.params.end_date).getTime();
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const categories = this.$communicator.then(
          this,
          await this.$communicator("sales_by_category", {
            arguments: [start_date, end_date, limit, page],
            params: {
              search: this.search,
              custom: this.params.custom,
              start: this.params.start.time,
              end: this.params.end.time,
              services: this.params.service != "" ? [this.params.service] : [],
              employees:
                this.params.employee._id != ""
                  ? [this.params.employee._id]
                  : [],
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...categories?.data);
      }
      this.proccesDialog = false;

      const result = await all_data.map((cat) => ({
        category_name: cat.category_name,
        cost_of_goods:
          Math.round(cat.cost_of_goods * current_currency) / current_currency,
        discounts:
          Math.round(cat.discounts * current_currency) / current_currency,
        gross_profit:
          Math.round(cat.gross_profit * current_currency) / current_currency,
        gross_sales:
          Math.round(cat.gross_sales * current_currency) / current_currency,
        items_refunded:
          Math.round(cat.items_refunded * current_currency) / current_currency,
        items_sold: Math.round(cat.items_sold * 100) / 100,
        net_sales:
          Math.round(cat.net_sales * current_currency) / current_currency,
        refunds: Math.round(cat.refunds * current_currency) / current_currency,
      }));
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "Categories.xlsx");
    },
  },
  mounted() {
    this.get_currency();
    this.current_currency = this.currentCurrency == "usd" ? 100 : 1;
    this.headers = [
      {
        text: this.$t(`category`),
        value: "category_name",
        available: true,
        disabled: true,
      },
      { text: this.$t(`items_sold`), value: "items_sold", available: true },
      { text: this.$t(`gross_sales`), value: "gross_sales", available: false },
      {
        text: this.$t(`items_refunded`),
        value: "items_refunded",
        available: false,
      },
      { text: this.$t(`refunds`), value: "refunds", available: false },
      { text: this.$t(`discounts`), value: "discounts", available: false },
      { text: this.$t(`net_sales`), value: "net_sales", available: true },
      {
        text: this.$t(`cost_of_goods`),
        value: "cost_of_goods",
        available: true,
      },
      { text: this.$t(`gross_profit`), value: "gross_profit", available: true },
      // {text: 'Taxes', value: 'taxes', available: false}
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
